export const textos = {
  promocionAgregada: 'Promoción agregada',
  errorAgregarPromocion: 'No se pudo agregar la promoción',
  cuponValido: 'Cupón Válido',
  cuponInvalido: 'Cupón Inválido',
};
